export const useNotification = () => {
  return null;
};
